<template>
  <div class="goods-list">
    <div class="mgr">
      <div class="amount-surplus">
        <div class="balance" @click="handleClickShowTip(false)">
          余额 <i></i> {{ amount.quizRemainNum > 999999 ? '999999' : amount.quizRemainNum }}
        </div>
        <div class="surplus" @click="handleClickShowTip(true)">
          <i class="saishi"></i> {{ amount.matchRemainNum }}
        </div>
        <div v-if="showPopup" class="popup">
          <div class="popup-content">
            <!-- <span>
              {{ tipTxt==false ? '可用于参与竞猜、送礼;获取途径：参与赛事中心活动、竞猜，游戏内活动获得。' : '可用于参与赛事转盘，获取后需前往游戏内邮箱领取方可到账;获取途径：参与赛事中心活动，游戏内购买获得。' }}
            </span> -->
            <span v-if="tipTxt">
              可用于参与赛事转盘，获取后需前往游戏内邮箱领取方可到账;<br/>获取途径：参与赛事中心活动，游戏内购买获得。
            </span>
            <span v-else>
              可用于参与竞猜、送礼 <br/>获取途径：参与赛事中心活动、竞猜，游戏内活动获得。
            </span>
          </div>
        </div>
      </div>
      <mallExchange :goodsList="mall.goodsList" :title="'每日商城'" @exchange="exchange" type="mall" />
      <mallExchange :goodsList="mall.resident" :title="'常驻商城'" @exchange="exchange" type="resident" />
    </div>

    <Prompt ref="prompt"></Prompt>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Prompt from '@/components/prompt'
import mallExchange from '@/components/mallExchange/mallExchange.vue'
export default {
  name: 'goodsList',
  data() {
    return {
      showPopup: false,
      tipTxt:false,
      tipock : false
    }
  },
  components: {
    // Exchange,
    Prompt,
    mallExchange
  },
  computed: {
    ...mapState(['matchAmount', 'token', 'amount', 'mall'])
  },
  created() {
    this.getGoodsList()
  },
  methods: {
    ...mapMutations(["SHOW_POPUP"]),
    ...mapActions(["reqUserInfo", "getGoodsList"]),
    exchange(goods, type) {
      let isType = type == 'mall' ? true : false
      let goodList = goods
      let limit = isType ? goodList.dailyLimit - goodList.dailyReward : goodList.totalLimit - goodList.totalReward
      //  赛事币
      if (limit > 0) {
        if (this.amount.quizRemainNum >= goodList.cost) {
          // this.$refs.exchange.exchange(goodList, type)
          this.SHOW_POPUP({
            id: 'exchange',
            params: {
              goodList: goodList,
              type: type
            }
          })
          // 埋点
          // if (typeof tapdb == 'undefined') return
          // tapdb.trackEvent('点击查看商品', {
          //   '#item_id': goodList.desc
          // })
        } else {
          this.$refs.prompt.setMsg('竞猜币不够，稍后再来吧～')
        }
      } else {
        isType ? this.$refs.prompt.setMsg(
          `已达兑换上限～ （${goodList.dailyReward}/${goodList.dailyLimit}）`
        ) :
          this.$refs.prompt.setMsg(
            `已达兑换上限～ （${goodList.totalReward}/${goodList.totalLimit}）`
          )
      }
    },
    handleHistory() {
      this.$refs.history.history()
    },
    handleClickShowTip(value) {
      if(!this.tipock){
        this.tipock = true
        this.showPopup = true
        this.tipTxt = value
        setTimeout(() => {
          this.showPopup = false
          this.tipock = false
        }, 3000)
      }
    },
  }
};
</script>


<style lang="scss" scoped>
.goods-list {
  overflow: scroll;
  height: 100%;

  .mgr {
    position: relative;
    overflow-y: scroll;
  }

  .amount-surplus {
    box-sizing: border-box;
    position: absolute;
    // top: get_vh(25px);
    // right: get_vh(15px);
    top: 0;
    right: 0;
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    height: get_vw(40px);
    line-height: get_vw(40px);
    background-color: rgba(0, 0, 0, 0.5);
    border: get_vw(2px) solid rgba(255, 255, 255, 0.2);
    border-radius: get_vw(10px);
    padding: 0 get_vw(16px);
    color: #fff;
    font-size: get_vw(20px);
    z-index: 1;

    .balance {
      display: inline-flex;
      justify-content: flex-end;
      align-items: center;

      i {
        display: inline-block;
        @include sprite_bg('quiz_coin');
        margin: 0 get_vw(10px);
        width: get_vw(24px);
        height: get_vw(26px);
      }
    }

    .surplus {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      i {
        display: inline-block;
        @include sprite_bg('quiz_coin');
        margin: 0 get_vw(10px);
        width: get_vw(26px);
        height: get_vw(27px);
      }

      .saishi {
        background-image: url('https://website.xdcdn.net/poster/355916/sausage-match/FwfgNkZW.png');
      }
    }

    .popup{
      width: get_vw(300px);
      border-radius: get_vw(10px);
      background: rgba(0, 0, 0, 0.8);
      position: absolute;
      top: get_vw(50px);
      right: 0;
      .popup-content{
        text-align: left;
        font-size: get_vw(16px);
        line-height: get_vw(24px);
        color: #fff;
        margin: get_vw(8px)
      }
    }
  }
}
</style>